module.exports = require("prismjs/components/prism-lua.js");